import React, {Component} from 'react';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import './css/sidebar-css.css';
import {getGlobalDomainName} from '../functions/functions';

import Dashboard from './Dashboard';
import redisDbSizes from './redisDbSizes';

import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import ConnectedDevices from "./ConnectedDevices";
import AuthenticatedDevices from "./AuthenticatedDevices";
import ProcessStatuses from "./ProcessStatuses";
import RedisGlobalVars from "./redisGlobalVars";
import BroadcastNotifications from "./BroadcastNotifications";
import AuthTokensList from "./AuthTokensList";
import RedisInstancesStatus from "./RedisInstancesStatus";
import DeviceCacheNotifierRedisInstances from "./DeviceCacheNotifierRedisInstances";


class LeftSidebarRouter extends Component {

    constructor(props) {
        super(props);

        this.changeDomainName = this.changeDomainName.bind(this);

        this.state = {
            domains: {},
        };
    }

    onClick() {
        return function () {
            console.log('my button is called!');
            $("#wrapper").toggleClass("toggled");
        }
    }

    setDomains(domains) {
        this.setState({
            domains: domains
        });
        return this;
    }

    chooseEnv(env_name) {
        return () => {
            if (env_name == 'mcf_dev') {
                global.mainDomainName = 'https://dev-crm.mcf.md/api_http/';
            } else if (env_name == 'mcf_prod') {
                global.mainDomainName = 'https://crm.mcf.md/api_http/';
            } else if (env_name == 'default') {
                global.mainDomainName = '/api_http/';
            } else if (env_name == 'sfa_dev') {
                global.mainDomainName = 'https://sfa-dev.wippo.it/api_http/';
            } else if (env_name == 'nanu_dev') {
                global.mainDomainName = 'https://nanu.dev.wippo-it.net/api_http/';
            } else if (env_name == 'democrm') {
                global.mainDomainName = 'https://democrm-v10-sfalite--dev.wippo-it.net/api_http/';
            } else if (env_name == 'dufa') {
                global.mainDomainName = 'https://dufa-crm.dev.wippo-it.net/api_http/';
            } else if (env_name == 'tanleo') {
                global.mainDomainName = 'https://crm.tanleo.md/api_http/';
            }
        }
    }

    changeDomainName(e) {
        global.mainDomainName = $(e.target).data('url');
    }

    createRouteLink(path) {
        // return path + '&' + getGlobalDomainName();
        return path;
    }

    getDomains() {
        let _this = this;
        // Get Domains

        $.ajax({
            url: 'https://crm-repo.wippo-it.net/api/sync_domains',
            type: 'GET',
            crossDomain: true,
            // async: true,
            // data: 'twitterUsername=jquery4u',
            success: function (data) {
                console.log(data);
                _this.setDomains(data);
            },
            error: function (e) {
                console.log('error...');
                //called when there is an error
                //console.log(e.message);
            }
        });
    }

    componentDidMount() {
        this.getDomains();
        let _this = this;
        setInterval(function () {
            _this.getDomains();
        }, 20000);
    }


    render() {
        let _this = this;
        return (
            <Router>
                <div id="wrapper">
                    <div id="sidebar-wrapper">
                        <ul className="sidebar-nav">
                            <li>
                                <Link to={this.createRouteLink('')}>Dashboard</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('redis_db_sizes')}>Redis DB Sizes</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('connected_devices')}>Connected Devices</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('authenticated_devices')}>Authenticated Devices</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('websocket_server_stats')}>Get Web Socket Stats</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('processes_statuses')}>Processes Statuses</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('redis_global_vars')}>Redis Global Vars</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('broadcast_notifications')}>Broadcast
                                    Notifications</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('auth_tokens')}>Auth Tokens</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('status_redis_instances')}>Redis Instances Status</Link>
                            </li>
                            <li>
                                <Link to={this.createRouteLink('status_device_cache_notifier_redis')}>Device Cache Not.
                                    Redis Status</Link>
                            </li>
                            <li>
                                <div className="dropdown">
                                    <button className="btn btn-secondary dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        CHOOSE ENV
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        {Object.keys(this.state.domains).map((v, i) => {
                                            let domain_data = _this.state.domains[v];
                                            return (
                                                <a data-url={domain_data.url} onClick={_this.changeDomainName}
                                                   className="dropdown-item"
                                                   href="#">{domain_data.label}</a>
                                            );
                                        })}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div id="page-content-wrapper">
                        <div id="left-sidebar-button">
                            <button onClick={this.onClick()} className="btn btn-primary">Open Sidebar</button>
                        </div>

                        {/*HERE IS THE CONTENT!!!*/}
                        <Switch>
                            <Route exact path='/' component={Dashboard}/>
                            <Route exact path='/redis_db_sizes' component={redisDbSizes}/>
                            <Route exact path='/connected_devices' component={ConnectedDevices}/>
                            <Route exact path='/authenticated_devices' component={AuthenticatedDevices}/>
                            <Route exact path='/processes_statuses' component={ProcessStatuses}/>
                            <Route exact path='/redis_global_vars' component={RedisGlobalVars}/>
                            <Route exact path='/broadcast_notifications' component={BroadcastNotifications}/>
                            <Route exact path='/auth_tokens' component={AuthTokensList}/>
                            <Route exact path='/status_redis_instances' component={RedisInstancesStatus}/>
                            <Route exact path='/status_device_cache_notifier_redis'
                                   component={DeviceCacheNotifierRedisInstances}/>
                        </Switch>
                    </div>
                </div>
            </Router>
        );
    }
}

export default LeftSidebarRouter;



// WEBPACK FOOTER //
// ./src/components/left-sidebar-router.js